<template>
  <div>
    <Title :pages="[{ icon: 'boxes-stacked', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <v-btn flat class="mb-3 btn-second" @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>
      <v-btn outlined class="ml-3 mb-3 btn-third" @click="updateDialogImportExcel(true)">Importar {{ modal_title }}</v-btn>

      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
      />

      <ModalImportExcel
        v-if="create_access"
        :button_name="'Importar ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        formBtn="Importar"
        :dialog="dialog_import_excel"
        :service="service"
        @updateDialog="updateDialogImportExcel"
        @loadList="loadList(service)"
      />

      <v-card v-if="list_access" class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="hasta" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.almacen"
                    density="comfortable"
                    name="almacen"
                    item-title="name"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.lpn" density="comfortable" type="text" name="lpn" label="Codigo de LPN" :disabled="disabled" clearable></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.product"
                    density="comfortable"
                    name="product"
                    item-title="label"
                    item-value="id"
                    :items="products"
                    label="Producto"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div :class="'col-md-9 pt-2'" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-2 pb-2" style="background:rgb(237,237,237); elevation-0">
          <div class="row">
            <div class="col-12">
              <v-btn color="info" variant="text" @click="openFilterModal" small>+ Agregar filtros adicionales</v-btn>

              <v-chip v-for="(filter, index) in selected_filters" :key="index" class="ml-2" closable @click:close="removeFilter(index)"> {{ filter.label }}: {{ filter.value }} </v-chip>
            </div>
          </div>
        </div>
      </v-card>

      <ModalFilterAttribute
        v-model="dialog_filters"
        title="Filtros Adicionales"
        :filters="filters"
        :qualities="qualities"
        :states="states"
        :loading="loading"
        :is-alias-enabled="isAliasEnabled"
        :get-alias-name="getAliasName"
        :show-expiration-date="true"
        @update:filters="updateFilters"
        @close="closeFilterModal"
        @apply="applyFilters"
      />

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col cols="auto">
              <span>{{ page_title }}</span>
            </v-col>
            <v-col>
              <v-btn :color="allExpanded ? 'blue-grey' : 'blue-grey'" variant="outlined" size="small" @click="toggleExpandAll" class="mr-3">
                <v-icon start>{{ allExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                {{ allExpanded ? "Contraer Todo" : "Expandir Todo" }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table v-if="list_access" :headers="compactHeaders" :items="items" :search="search" :loading="loading" loading-text="Cargando..." item-value="id" class="elevation-1">
          <template v-slot:[`header.main_attribute`]="{ column }">
            <div class="d-flex align-center header-sort-hover">
              <span>{{ column.title }}</span>
              <v-icon 
                size="small" 
                :color="sortByMainAttribute ? 'primary' : undefined"
                @click="toggleMainAttributeSort"
                class="ml-1 cursor-pointer sort-icon"
                :class="{ 'sort-active': sortByMainAttribute }"
              >
                {{ sortByMainAttribute ? (sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down') : 'mdi-arrow-up' }}
              </v-icon>
            </div>
          </template>
          <template v-slot:item="{ item, index }">
            <tr>
              <td>
                <v-btn variant="text" size="small" @click="toggleExpand(index)" icon>
                  <v-icon>{{ isExpanded(index) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                </v-btn>
              </td>
              <td>{{ item.id }}</td>

              <td>
                {{ item.date_time.split(" ")[0] }}<br />
                <span class="text-caption text-grey-600 d-block">{{ item.date_time.split(" ")[1] || "" }}</span>
                <span class="text-caption text-grey-600 d-block">{{ item.user_username }}</span>
              </td>
              <td>
                {{ item.product_name }}
                <span class="text-caption text-grey-600 d-block no-wrap">SKU: {{ item.product_sku }}</span>
              </td>
              <td>
                <v-chip size="small" :color="getStatusColor(item.product_status_id)">
                  <b>{{ item.product_status_name }}</b>
                </v-chip>
              </td>
              <td>
                <div v-if="getMainAttribute(getAttributes(item))">
                  <span class="font-weight-bold pb-1 text-caption">{{ getMainAttribute(getAttributes(item)).label }}</span> <br />
                  <span class="text-caption text-grey-600">{{ getMainAttribute(getAttributes(item)).value }}</span>
                </div>
              </td>

              <td>
                <div class="pt-2 pb-2">
                  <div class="font-weight-medium">{{ item.lpn_code }}</div>
                  <v-chip size="small" class="mt-1 mb-1">{{ item.lpn_state_name }}</v-chip>
                </div>
              </td>

              <td>
                <div class="nowrap">{{ item.ubicacion_code }}</div>
                <span class="text-caption text-grey-600 d-block">{{ item.zona_name || "" }}</span>
                <span class="text-caption text-grey-600 d-block">{{ item.almacen_name || "" }}</span>
              </td>

              <td class="text-center">
                <div class="d-flex align-center font-weight-bold">
                  <div
                    class="font-weight-bold text-stock"
                    :class="{
                      'text-success': item.ajuste_type === service.TYPE_POSITIVO,
                      'text-error': item.ajuste_type !== service.TYPE_POSITIVO,
                    }"
                  >
                    {{ item.ajuste_type === service.TYPE_POSITIVO ? "+" : "-" }}{{ item.base_amount }}
                  </div>
                  <div class="text-caption text-grey-600 flex-shrink-0 mt-1 presentation-type">
                    {{ getPresentationTypeName(item.base_amount, item.presentation_type_id, item.presentation_type_name) }}
                  </div>
                </div>
              </td>
              <td>{{ item.observation }}</td>
            </tr>
            <tr v-if="isExpanded(index)" :key="`expanded-${index}`">
              <td :colspan="compactHeaders.length" class="pa-0">
                <div class="pa-4 bg-grey-lighten-5">
                  <h6 class="mb-3 ml-4">Detalles Adicionales</h6>
                  <v-row class="ml-1">
                    <v-col cols="12" md="3">
                      <span class="font-weight-bold pb-1 text-caption">Cliente</span>
                      <div>{{ item.client_name }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.pa_expiration_date">
                      <span class="font-weight-bold pb-1 text-caption">Vencimiento</span>
                      <div>{{ item.pa_expiration_date }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.quality_id">
                      <span class="font-weight-bold pb-1 text-caption">Calidad</span>
                      <div>
                        <v-chip size="small" color="primary">
                          {{ item.quality_name }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.pa_lote">
                      <span class="font-weight-bold pb-1 text-caption">Lote</span>
                      <div>{{ item.pa_lote }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.pa_serie">
                      <span class="font-weight-bold pb-1 text-caption">Serie</span>
                      <div>{{ item.pa_serie || "N/A" }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="isAliasEnabled('descriptivo_1') && item.pa_descriptivo_1">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_1") }}</span>
                      <div>{{ item.pa_descriptivo_1 }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="isAliasEnabled('descriptivo_2') && item.pa_descriptivo_2">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_2") }}</span>
                      <div>{{ item.pa_descriptivo_2 }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="isAliasEnabled('descriptivo_3') && item.pa_descriptivo_3">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_3") }}</span>
                      <div>{{ item.pa_descriptivo_3 }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.pa_storage_units_amount">
                      <span class="font-weight-bold pb-1 text-caption">Valor de Almacenamiento</span>
                      <div>{{ item.pa_storage_units_amount }}</div>
                    </v-col>
                  </v-row>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { historialAjusteService } from "@/libs/ws/historialAjusteService";
import { almacenService } from "@/libs/ws/almacenService";
import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Modal from "./Modal.vue";
import ModalFilterAttribute from "@/components/ModalFilterAttribute.vue";
import { productoService } from "@/libs/ws/productoService";
import { productQualityService } from "@/libs/ws/productQualityService";
import { formatUtils } from "@/libs/utils/formatUtils";
import ModalImportExcel from "./ModalImportExcel.vue";

export default {
  components: { Modal, ModalFilterAttribute, ModalImportExcel },
  mixins: [GenericMixin, RolMixin, AliasMixin, ExportMixin],
  data() {
    return {
      service: historialAjusteService,
      page_title: "Ajuste Manual",
      modal_title: "Ajuste Manual",
      userTypeConstant: UserTypeConstant,
      user_type: null,
      filters: {
        date_from: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        almacen: null,
        lpn: null,
        product: null,
        state: null,
        lote: null,
        serie: null,
        descriptivo_1: null,
        descriptivo_2: null,
        descriptivo_3: null,
        quality: null,
        storage_units_amount: null,
        expiration_date: null,
        storage_units_amount_operator: null,
        expiration_date_operator: null,
      },
      dialog_filters: false,
      selected_filters: [],
      qualities: [],
      states: [],
      almacen: null,
      almacenes: [],
      products: [],
      dialog_import_excel: false,
    };
  },
  computed: {
    compactHeaders() {
      return [
        { title: "", key: "data-table-expand", sortable: false, width: "48px" },
        { title: "Numero", key: "id", sortable: true, align: "left" },
        { title: "Creacion", key: "user_username", sortable: true, align: "left" },
        { title: "Producto", key: "productSearch", sortable: true, align: "left" },
        { title: "Estado", key: "product_status_name", sortable: true, align: "left" },
        { 
          title: "Atributo principal", 
          key: "main_attribute", 
          sortable: false, 
          align: "left",
          width: "200px"
        },
        { title: "LPN ", key: "lpn_code", sortable: true, align: "left" },
        { title: "Ubicación", key: "ubicacion_code", sortable: true, align: "left" },
        {
          title: "Cantidad",
          key: "base_amount",
          sortable: true,
          align: "center",
        },
        {
          title: "Observación",
          key: "observation",
          sortable: false,
          align: "left",
        },
      ];
    },
    items() {
      const mappedItems = this.list.map((item) => ({
        ...item,
        productSearch: `${item.product_name || ""} ${item.product_sku || ""}`,
      }));
      
      // Aplicar ordenamiento por atributo principal usando el mixin
      return this.sortItemsByMainAttribute(
        mappedItems,
        (item) => this.getAttributes(item)
      );
    },
  },
  mounted() {
    this.loadAliasMap();

    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadProducts();
    this.loadStatesProducts();
    this.loadQualities();
  },
  methods: {
    //El backend devuelve campos planos; getMainAttribute() del AliasMixin espera la estructura
    //de PresentationAtributes, asi que se rearma solo lo que ese metodo consume.
    getAttributes(item) {
      return {
        expiration_date: item.pa_expiration_date,
        lote: item.pa_lote,
        serie: item.pa_serie,
        storage_units_amount: item.pa_storage_units_amount,
        quality: item.quality_id ? { id: item.quality_id, name: item.quality_name } : null,
        descriptivo_1: item.pa_descriptivo_1,
        descriptivo_2: item.pa_descriptivo_2,
        descriptivo_3: item.pa_descriptivo_3,
        product_presentation: { product: { storage_unit_name: item.storage_unit_name } },
      };
    },
    updateDialogImportExcel(value) {
      if (!value) {
        this.close();
      }
      this.dialog_import_excel = value;
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadStatesProducts() {
      productoService.getStates().then((response) => {
        this.states = response.result.list;
      });
    },
    loadProducts() {
      productoService.list_minify().then((response) => {
        this.products = response.result.list;
      });
    },
    getFilterParams() {
      this.selected_filters = [
        { key: "lpn", label: "LPN", value: this.filters.lpn },
        { key: "state", label: "Estado Producto", value: this.filters.state != null ? this.filters.state.name : "" },
        { key: "lote", label: "Lote", value: this.filters.lote },
        { key: "serie", label: "Serie", value: this.filters.serie },
        { key: "descriptivo_1", label: this.getAliasName("descriptivo_1"), value: this.filters.descriptivo_1 },
        { key: "descriptivo_2", label: this.getAliasName("descriptivo_2"), value: this.filters.descriptivo_2 },
        { key: "descriptivo_3", label: this.getAliasName("descriptivo_3"), value: this.filters.descriptivo_3 },
        { key: "quality", label: "Calidad", value: this.filters.quality != null ? this.filters.quality.name : "" },
        {
          key: "storage_units_amount",
          label: "Valor de almacenamiento",
          value:
            this.filters.storage_units_amount && this.filters.storage_units_amount_operator
              ? `${this.filters.storage_units_amount_operator.label} ${this.filters.storage_units_amount}`
              : this.filters.storage_units_amount,
        },
        {
          key: "expiration_date",
          label: "Fecha de vencimiento",
          value:
            this.filters.expiration_date && this.filters.expiration_date_operator
              ? `${this.filters.expiration_date_operator.label} ${formatUtils.formatDateString(this.filters.expiration_date)}`
              : this.filters.expiration_date,
        },
      ].filter((f) => f.value);
      return this.filters;
    },
    filter() {
      this.loadList(this.service, this.filters);
    },
    exportFile() {
      var param = { ...this.getFilterParams() };
      param["export"] = true;
      this.exportExcel("ajuste-manual/export-historial", param, "AjusteManual.xlsx");
    },
    loadList(service) {
      this.loading = true;

      const param = {
        enable: true,
        from: this.current_page,
        //limit: this.$store.state.config.items_per_page,
      };

      //agrego los parametros a param
      Object.assign(param, this.getFilterParams());

      this.open_filter = false;
      service
        .list_historial(param)
        .then((response) => {
          if (param.from == 0) {
            this.current_page = 1;
          }
          this.list = response.result.list;
          this.cant_pages = Math.ceil(response.result.total / this.$store.state.config.items_per_page);
          this.total = response.result.total;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openFilterModal() {
      this.dialog_filters = true;
    },
    closeFilterModal() {
      this.dialog_filters = false;
    },

    updateFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
    },

    applyFilters() {
      this.filter();
      this.closeFilterModal();
    },
    loadQualities() {
      productQualityService.filter({}).then((response) => {
        this.qualities = response.result.list;
      });
    },

    removeFilter(index) {
      const filtered = this.selected_filters[index];
      this.selected_filters.splice(index, 1);

      if (filtered.key) {
        this.filters[filtered.key] = null;
        if (filtered.key === "storage_units_amount") {
          this.filters.storage_units_amount_operator = null;
        } else if (filtered.key === "expiration_date") {
          this.filters.expiration_date_operator = null;
        }
      }

      this.filter();
    },
    getStatusColor(status) {
      switch (parseInt(status)) {
        case productoService.PRODUCT_STATUS_DISPONIBLE:
          return "success";
        case productoService.PRODUCT_STATUS_BLOQUEADO:
          return "warning";
        case productoService.PRODUCT_STATUS_CUARENTENA:
          return "info";
        case productoService.PRODUCT_STATUS_VENCIDO:
          return "error";
        default:
          return "primary";
      }
    },
  },
};
</script>
